import { useMemo } from 'react'
import PropTypes from 'prop-types'

import { getFeature, getModelValue } from '@aytm/app/stats/lib/stat-page'

import {
  calcPartialProps,
  resolveSigtestKeys
} from '@aytm/app/stats/page/question-views/cl/components/partial/lib/props'

// components
import { default as CompareItems } from '@aytm/app/stats/page/question-views/info-view/components/compare-items/Block'
import ReloadScreen from '@aytm/app/stats/page/question-views/components/questions-custom/ReloadScreen'

// The concept-lab partial: the concepts the researcher mapped, compared attribute by attribute.
// It derives the compare-items payload from the raw mapping the question holds -- the entities as
// batches, the attributes as their answer variants -- and hands the survey-coupled work (the
// report-param write and the export) back to the shell through the api it publishes on mount.
const Block = ({ model, params, paramsRevision, reloadNeeded, onReady, onStateChange, onExport }) => {
  // read per render: the shell redraws on a page-level change without minting a new payload
  const { level, pair } = resolveSigtestKeys()
  const percentDecimals = getModelValue('percentDecimals')

  const props = useMemo(
    () =>
      calcPartialProps({
        id: model.id,
        key: model.key,
        text: model.text,
        answer: model.answer,
        entities: model.entities,
        attributes: model.attributes,
        splitBy: model.splitBy,
        features: model.features,
        keys: { level, pair },
        percentDecimals
      }),
    [model, level, pair, percentDecimals]
  )

  return (
    <>
      <CompareItems
        id={props.key}
        params={params}
        paramsRevision={paramsRevision}
        title=""
        fullScreenTitle={props.title}
        itemName={props.format.itemName}
        format={props.format}
        batches={props.batches}
        answer={props.answer}
        splitBy={props.splitBy}
        percentDecimals={props.percentDecimals}
        footer={<>&nbsp;</>}
        showExportButton={true !== getFeature('authorized_exports')?.disabled}
        onReady={onReady}
        onStateChange={onStateChange}
        onExport={onExport}
      />
      <ReloadScreen reloadNeeded={reloadNeeded} />
    </>
  )
}

Block.propTypes = {
  model: PropTypes.object.isRequired,
  params: PropTypes.object,
  paramsRevision: PropTypes.number,
  reloadNeeded: PropTypes.bool,
  onReady: PropTypes.func,
  onStateChange: PropTypes.func,
  onExport: PropTypes.func
}

export default Block
